import React, { useEffect, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import CustomInput from '../../InputCompo/CustomInput'
import * as Yup from 'yup';
import { LoginPageDocuments as documents } from './documents'
import { Form, Formik, replace, useFormik, useFormikContext } from 'formik'
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp'
import ButtonComp from '../../ButtonComp/ButtonComp'
import { Link, useNavigate } from 'react-router-dom'
import EastIcon from '@mui/icons-material/East';
import PersonIcon from '@mui/icons-material/Person';
import GroupsIcon from '@mui/icons-material/Groups';
import CloseIcon from '@mui/icons-material/Close';
import { useMutation, useQuery } from '@tanstack/react-query'
import { enqueueSnackbar } from 'notistack'
import { RegistrationNpoSearch, UserLogin } from '../../../Store/auth/login';
import { NpoLogin } from '../../../Store/auth/login';
import LoginSelectButton from './components/LoginSelectButton'
import ForgetPassword from "./Popups/ForgetPassword";
import NewPassword from "./Popups/NewPassword";
import NeedHelp from "./Popups/NeedHelp";
import { useLocation } from 'react-router-dom';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// import required modules
import { ImageComp } from '../../ImageCompo/ImageComp'
import ModalComp from '../../ModalComp';
import HeaderCompo from '../../HeaderComp/HeaderCompo';
import Loading from '../../Loader/Loading';

const DatauserLogin = () => {

    const location = useLocation();
    const isNPOs = location.state?.isNPO;

    console.log('isNPOs', isNPOs);


    const navigate = useNavigate()
    const [forgetPassword, setForgetPassword] = useState(false);
    const [newPassword, setNewPassword] = useState(false);
    const [needHelp, setNeedHelp] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false)
    const CarouselImages = ['Frame 1000003230.png', '3.png']
    const [filters, setFilters] = useState({ pan: true })
    const [filteredNpo, setFilteredNpos] = useState()
    const [selected, setSelected] = useState(!isNPOs ? 'user' : 'ngo')
    const [passingData, setPassingData] = useState({})
    const [EmailData, setEmailData] = useState({})

    const modelSchema = Yup.object().shape(
        documents.reduce((schema, field) => {
            if (field.mandatory === 1 && field.type.toLowerCase() !== 'section') {
                let validator = Yup.string().required(`${field.question} is required`);
                schema[field.question_no] = validator;
            }

            return schema;
        }, {})
    );

    // useEffect(() => {
    //     const email = localStorage.getItem('email');
    //     if (email) {
    //         navigate('/profile'); // Redirect to profile and replace history
    //     }
    // }, [navigate]);

    const formik = useFormik({
        initialValues: {
            ...documents.reduce((values, field) => {
                values[field.question_no] = '';
                return values;
            }, {}),
        },

        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                // Convert the form data into a flat object
                const tempData = {
                    ...documents.reduce((acc, field) => {
                        acc[field.question_no] = values[field.question_no];
                        return acc;
                    }, {}),
                };

                // Merge new data with existing data
                const updatedData = {
                    ...tempData,
                };
                if (selected === 'user') {
                    await loginMutate(updatedData);
                } else if (selected === 'ngo') {
                    await NpoLoginMutate(updatedData)
                }

            } catch (error) {
            } finally {
                setSubmitting(false);
            }
        },
    });
    const handleCreateSuccess = () => {
        enqueueSnackbar('Login success!', { variant: 'success' });
    };

    const handleUserCreateSuccess = (data) => {
        const email = data?.session
        if (email) {
            localStorage.setItem('email', email);
        }

        window.location.href = '/profile';
        enqueueSnackbar('Login success!', { variant: 'success' });

    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500 || error?.response.status >= 300) {
            enqueueSnackbar(error?.response?.data?.status_message, { variant: 'error' });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
        }
    };

    const handleforgetPassword = () => {
        setForgetPassword(!forgetPassword);
    };

    const handleNewPassword = () => {
        setNewPassword(!newPassword);
    };

    const handleNeedHelp = () => {
        setNeedHelp(!needHelp);
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };
    const npoSearchHandler = {
        onSuccess: handleUserCreateSuccess,
        onError: handleCreateError,
    };
    const userLoginMutationOptions = {
        onError: handleCreateError
    };

    //getting mutation alerts

    const {
        mutate: loginMutate,
        isPending: addDataUserLoading,
        // data: loginData
    } = useMutation({
        mutationFn: UserLogin,
        ...npoSearchHandler,
    });
    // npo login api
    const {
        mutate: NpoLoginMutate,
        isPending: addNpoLoading,
        data: NpoLoginData
    } = useMutation({
        mutationFn: NpoLogin,
        ...createFarmerMutationOptions,
    });

    useEffect(() => {
        if (NpoLoginData?.home_page) {
            localStorage.setItem('RegKey', NpoLoginData?.documents.document_name);
            localStorage.setItem('Db_name', NpoLoginData?.documents.db_name);

            // Navigate and force reload
            window.location.href = '/registration';
        }
    }, [NpoLoginData]);

    const clearRegKeyOnLocal = () => {
        openModal()
    };

    const openModal = () => {
        setIsOpenModal(true)
    }
    const closeModal = () => {
        setIsOpenModal(false)
        setFilters({ pan: true })
        setFilteredNpos('')

    }

    const SignupSchema = Yup.object().shape({
        pan: filters.pan || filters?.fill ? Yup.string().required().matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Number. It should be in the format: ABCDE1234F."
        ) : Yup.string(),
        darpan: filters.darpan ? Yup.string().required().matches(
            /^([A-Z]{2}\/\d{4}\/\d{7})$/, 'Darpan Id should be in the format: XX/1234/1234567'
        ) : Yup.string(),
        name: filters?.name || filters?.fill ? Yup.string().required() : Yup.string(),
        person_name: filters?.fill ? Yup.string().required() : Yup.string(),
        email: filters?.fill ? Yup.string().required().matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
        ) : Yup.string(),
        gsi_number: filters?.fill ? Yup.string().required() : Yup.string(),
        number: filters?.fill ? Yup.string().required().matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Mobile number must be exactly 10 digits') : Yup.string(),
    });

    const submitData = (data, which) => {
        const key = Object.keys(filters)[0]
        setPassingData({ key: key, data: data?.[key] })
        if (which === 'whatsApp') {
            setEmailData(data)
        }
    }

    useEffect(() => {
        if (passingData?.data) {
            reCallApi(passingData)
        }
    }, [passingData])

    useEffect(() => {
        if (EmailData?.name) {
            sendToEmail();
        }
    }, [EmailData]);

    const sendToEmail = () => {
        const subject = "Details Submission";
        const body = `PAN: ${EmailData.pan}\nName: ${EmailData.name}\nPerson Name: ${EmailData.person_name}\nEmail: ${EmailData.email}\nGSI Number: ${EmailData.gsi_number}\nNumber: ${EmailData.number}`;
        const mailtoLink = `mailto:info@guidestarindia.org?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.open(mailtoLink, '_blank');
    };




    const {
        mutate: reCallApi,
        isPending: fieldLoading,
        data: findNpos,
        error: errorNpo
    } = useMutation({
        mutationFn: RegistrationNpoSearch,
        ...userLoginMutationOptions,
    });



    useEffect(() => {
        if (findNpos?.docs_answers?.length > 0) {
            setFilteredNpos(findNpos?.docs_answers)
        } else {
            setFilteredNpos('')
        }
        setPassingData('')
    }, [findNpos])

    useEffect(() => {
        if (errorNpo) {
            if (errorNpo.response.status >= 400 && Object.keys(filters)[0] === 'pan') {
                setFilters({ darpan: true })
            }
            else if (errorNpo.response.status >= 400 && Object.keys(filters)[0] === 'darpan') {
                setFilters({ name: true })
            } else if (errorNpo.response.status >= 400 && Object.keys(filters)[0] === 'name') {
                setFilters({ tryAgain: true })
            }
        }
    }, [errorNpo])

    const ContactBox = (name) => {
        setFilters({ [name]: true })
        setFilteredNpos('')
    }

    const tryAgain = () => {
        setFilters({ pan: true })
    }

    const updateApplicationNum = (application_no, db) => {
        if (db === 'GSI DB' || db === 'Pending DB') {
            closeModal()
            enqueueSnackbar('Please enter your email and password', { variant: 'success' });
            setSelected('ngo')
        } else if (db === 'Raw Data DB') {
            window.location.href = '/registration'
            localStorage.setItem('RegKey', application_no)
            localStorage.setItem('Db_name', db)
        }
    }
    const DisplayFormikValues = () => {
        const { values, errors } = useFormikContext();
        return null; // You can return JSX or null if you just want to log the values
    };

    const ReRenderPage = () => {
        localStorage.removeItem('RegKey')
        localStorage.removeItem('Db_name')
        localStorage.removeItem('gsn_no')
        navigate('/registration')
    }

    const openName = () => {
        setFilters({ name: true })
    }


    useEffect(() => {
        if (location?.pathname === '/npo-login') {
            setSelected('ngo')
        } else if (location?.pathname === '/find-npos') {
            setIsOpenModal(true)
        }
        else if (location?.pathname === '/loginDataUser') {
            setSelected('user')
        }
    }, [location?.pathname])



    const clearRegData = () => {
        window.location.href = '/registration'
        localStorage.removeItem('RegKey')
        localStorage.removeItem('gsn_no')
        localStorage.removeItem('Db_name')
    }

    if (addNpoLoading || addDataUserLoading || fieldLoading) return (<Loading />)



    return (
        <>
            <Box sx={{ maxWidth: '100vw', overflow: 'hidden', color: 'black' }}>

                <Box sx={{ maxWidth: '1200px', margin: 'auto', display: 'flex', flexWrap: 'wrap', padding: 2 }}>
                    <Box sx={{ width: '45%', display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px', justifyContent: 'center', alignItems: 'center', width: '380px', margin: 'auto' }}>
                            <Box>
                                <Typography variant='h2' sx={{ fontWeight: 700, textAlign: 'center', fontSize: '54px' }}>WELCOME</Typography>
                                <Typography variant='subtitle1' sx={{ fontWeight: 400, fontSize: '12px', textAlign: 'center' }}>We are glad to see you here</Typography>
                            </Box>

                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <LoginSelectButton
                                    icon={PersonIcon}
                                    title="User"
                                    description="To look up NPO/ NGO information"
                                    isSelected={selected === 'user'}
                                    onSelect={() => {
                                        formik.resetForm()
                                        navigate('/loginDataUser', { replace: true })
                                    }}
                                />
                                <LoginSelectButton
                                    icon={GroupsIcon}
                                    title="Only NPO/ NGO User"
                                    description="To update information about your organisation"
                                    isSelected={selected === "ngo"}
                                    onSelect={() => {
                                        formik.resetForm();
                                        navigate("/npo-login", { replace: true });
                                    }}
                                    alert="Currently not functional. Please await email intimation"
                                />
                            </Box>

                            <form action="" onSubmit={formik.handleSubmit} className='w-[340px]'>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                                    {documents?.map(Fields =>
                                        <>
                                            {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' || Fields.type.toLowerCase() === 'password' ?
                                                <div className='w-[100%]'>
                                                    <CustomInput
                                                        type={Fields.type.toLowerCase()}
                                                        required
                                                        {...formik.getFieldProps(Fields.question_no)}
                                                        name={Fields.question_no} label={Fields.question}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                                                </div>
                                                : ''}
                                        </>
                                    )}
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                                        <Button onClick={handleforgetPassword} variant='text' disableRipple sx={{ color: '#004878', fontWeight: 600, padding: '0', textTransform: 'inherit', letterSpacing: '-.5px', '&:hover': { backgroundColor: 'transparent' } }}>Forgot Password ?</Button>
                                    </Box>
                                    <div className='flex justify-center'>
                                        <ButtonComp type={'submit'} text={'Login'} className='px-[50px] rounded-full bg-[#C00000] text-[white] py-[10px] leading-5' />
                                    </div>
                                </Box>
                            </form>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '340px' }}>
                                <ParagraphComp className='text-black text-base font-medium' text="Not yet registered? " />
                                <Link to='/find-npos' className='flex justify-start'>
                                    <Button variant='text' onClick={clearRegKeyOnLocal} disableRipple sx={{ color: '#004878', padding: '0', textTransform: 'inherit', letterSpacing: '-.5px', fontSize: '13px', fontWeight: 600, '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>To register your NPO/ NGO, click here. &nbsp; <EastIcon fontSize='small' /></Button>
                                </Link>
                                <Link to="/createAccount" className='flex justify-start'>
                                    <Button variant='text' disableRipple sx={{ color: '#004878', padding: '0', textTransform: 'inherit', letterSpacing: '-.5px', fontSize: '13px', fontWeight: 600, '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>To register as a User to browse information, click here. &nbsp; <EastIcon fontSize='small' /></Button>
                                </Link>
                                <Box sx={{ display: 'flex', gap: '10px' }}>
                                    <ParagraphComp className='text-black text-base font-medium' text="If you need any help, please " />
                                    <Link to="/contact" className='flex justify-start'>
                                        <Button variant='text' disableRipple sx={{ color: '#004878', padding: '0', textTransform: 'inherit', letterSpacing: '-.5px', fontSize: '13px', fontWeight: 600, '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' } }}>Contact Us &nbsp; <EastIcon fontSize='small' /></Button>
                                    </Link>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ width: '55%', borderRadius: '30px', padding: '30px', height: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '50px' }}>
                        {/* <Swiper
                            spaceBetween={30}
                            effect={'fade'}
                            autoplay={{
                                delay: 2000
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[EffectFade, Pagination, Autoplay]}
                            className="relative w-[100%] h-[100%]"  // Adjust height here
                        >
                            {CarouselImages.map((img, index) => (
                                <SwiperSlide className='w-[100%]' key={index}>
                                    <ImageComp source={`./Images/${img}`} className='object-cover w-full h-[100%]' />
                                </SwiperSlide>
                            ))}
                        </Swiper> */}
                        <div className='w-[100%] h-[100%] flex justify-center items-center'>
                            <ImageComp source={`./Images/WhatsApp Image 2025-02-06 at 16.02.53_3995bacb.jpg`} className='object-cover rounded-[30px] h-[70vh] w-full ] ' />
                        </div>
                    </Box>

                </Box>
                <ForgetPassword isOpen={forgetPassword} onClose={handleforgetPassword} />
                <NewPassword isOpen={newPassword} onClose={handleNewPassword} />
                <NeedHelp isOpen={needHelp} onClose={handleNeedHelp} />
            </Box>


            <ModalComp width='40%' modalIsOpen={isOpenModal} closeModal={closeModal} >
                {filteredNpo?.length <= 0 ?
                    <div className='w-[100%]'>
                        <div className='flex justify-end'>
                            <div onClick={closeModal} className='cursor-pointer'>
                                <CloseIcon />
                            </div>
                        </div>
                        {/* Start by Entering Your PAN */}
                        {filters?.['pan'] ?
                            <Formik
                                initialValues={{
                                    pan: '',
                                }}
                                validationSchema={SignupSchema}
                                onSubmit={submitData}
                            >
                                {({ errors, touched, values, handleChange, handleBlur }) => (
                                    <Form>
                                        <div className='flex flex-col p-[30px] gap-[20px] items-center'>
                                            <ImageComp source='./Images/panImg.png' className='h-[100px] w-fit' />
                                            <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='Start by Entering Your PAN' />
                                            <ParagraphComp className='text-md text-center ' text='We prioritise PAN for the most accurate match. Please enter your organisation’s PAN number to continue.' />
                                            <div className='w-[100%]'>
                                                <CustomInput
                                                    value={values?.pan}
                                                    name='pan'
                                                    required={true}
                                                    type='text'
                                                    className='w-[100%]'
                                                    label='Enter PAN'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur} />
                                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['pan'] && errors?.['pan']} />
                                            </div>
                                            <ButtonComp type='submit' text="Search Organisation" className='px-[40px] rounded-full bg-[#C00000] text-[white]' />
                                        </div>
                                        <DisplayFormikValues />
                                    </Form>
                                )}
                            </Formik>

                            //   No Match Found for PAN
                            : filters?.['darpan'] ?
                                <Formik
                                    initialValues={{
                                        darpan: '',
                                    }}
                                    validationSchema={SignupSchema}
                                    onSubmit={submitData}
                                >
                                    {({ errors, touched, values, handleChange, handleBlur }) => (
                                        <Form>
                                            <div className='flex flex-col p-[30px] gap-[20px] items-center'>
                                                <ImageComp source='./Images/errorImg.png' className='h-[100px] w-fit' />
                                                <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text="No match found for PAN. Don't worry, you can still proceed further." />
                                                <ParagraphComp className='text-md text-center ' text='We couldn’t find your organisation using the PAN you entered. Would you like to try using your Darpan ID instead?' />
                                                <div className='w-[100%]'>
                                                    <CustomInput
                                                        value={values?.darpan}
                                                        name='darpan'
                                                        required={true}
                                                        type='text'
                                                        className='w-[100%]'
                                                        label='Darpan ID'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur} />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['darpan'] && errors?.['darpan']} />

                                                </div>
                                                <ButtonComp text="Try Darpan ID" className='px-[40px] rounded-full bg-[#C00000] text-[white]' />
                                                <ParagraphComp className='text-md text-center'  >
                                                    If your organisation does not have a Darpan ID, you may proceed to the next step of searching with Organisation name by clicking "Do not have Darpan ID"
                                                </ParagraphComp>

                                                <ButtonComp onClick={openName} type='button' text="Do not have a Darpan ID" className='px-[40px] rounded-full bg-[#004878] text-[white]' />
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                                :
                                // {/* No Match Found for Darpan ID */}
                                filters?.['name'] ?
                                    <Formik
                                        initialValues={{
                                            name: '',
                                        }}
                                        validationSchema={SignupSchema}
                                        onSubmit={submitData}
                                    >
                                        {({ errors, touched, values, handleChange, handleBlur }) => (
                                            <Form>
                                                <div className='flex flex-col p-[30px] gap-[20px] items-center'>
                                                    <ImageComp source='./Images/errorImg.png' className='h-[100px] w-fit' />
                                                    <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='No Match Found for Darpan ID' />
                                                    <ParagraphComp className='text-md text-center ' text='We couldn’t find your organisation using the Darpan ID you entered. Would you like to try using your organisation name instead?' />
                                                    <div className='w-[100%]'>
                                                        <CustomInput
                                                            value={values?.name}
                                                            name='name'
                                                            required={true}
                                                            type='text'
                                                            className='w-[100%]'
                                                            label='Enter Organisation Name'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur} />
                                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['name'] && errors?.['name']} />                                    </div>
                                                </div>
                                                <div className='flex justify-center'>
                                                    <ButtonComp text="Try Organisation Name" className='px-[40px] rounded-full bg-[#C00000] text-[white]' />
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                    :
                                    filters?.['tryAgain'] ?
                                        < div className='flex flex-col p-[30px] gap-[20px] items-center'>
                                            <ImageComp source='./Images/errorImg.png' className='h-[100px] w-fit' />
                                            <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='No Match Found for Organisation Name' />
                                            <ParagraphComp className='text-md text-center ' text='We couldn’t find your organisation using the name you entered. You can register your organisation if it’s not in our system.' />
                                            <div className='flex gap-[10px]'>
                                                <ButtonComp onClick={tryAgain} text="Try Again" className='px-[40px] rounded-full bg-[#C00000] text-[white]' />
                                                <ButtonComp onClick={() => { ReRenderPage() }} text="Register Now" className='px-[40px] rounded-full bg-[#004878] text-[white]' />
                                            </div>

                                        </div>
                                        :
                                        filters?.['fill'] ?
                                            <Formik
                                                initialValues={{
                                                    pan: '',
                                                    name: '',
                                                    person_name: '',
                                                    email: '',
                                                    gsi_number: '',
                                                    number: '',
                                                }}
                                                validationSchema={SignupSchema}
                                                onSubmit={(data) => { submitData(data, 'whatsApp') }}
                                            >
                                                {({ errors, touched, values, handleChange, handleBlur }) => (
                                                    <Form>
                                                        <div className='flex flex-col p-[30px] gap-[20px] items-center'>
                                                            <ImageComp source='./Images/fillForm.png' className='h-[100px] w-fit' />
                                                            <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='Fill the Form' />
                                                            <div className='w-[100%] flex gap-[10px]'>
                                                                <div className='w-[100%]' >
                                                                    <CustomInput
                                                                        required={true}
                                                                        value={values?.gsi_number}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur} name='gsi_number' label='Guidestar Number' />
                                                                    <div className='h-[15px]'>
                                                                        <ParagraphComp className='text-[#C00000] leading-normal text-[10px] px-[8px] mt-1' text={values?.['gsi_number'] && errors?.['gsi_number']} />
                                                                    </div>
                                                                </div>
                                                                <div className='w-[100%]' >

                                                                    <CustomInput name='pan'
                                                                        value={values?.pan}
                                                                        required={true}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label='Organisation PAN' />
                                                                    <div className='h-[15px]'>

                                                                        <ParagraphComp className='text-[#C00000] text-[10px] leading-normal px-[8px] mt-1' text={values?.['pan'] && errors?.['pan']} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='w-[100%] flex gap-[10px]'>
                                                                <div className='w-[100%]' >
                                                                    <CustomInput value={values?.name}
                                                                        required={true}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur} name='name' label='NGO Name' />
                                                                    <div className='h-[15px]'>

                                                                        <ParagraphComp className='text-[#C00000] text-[10px] leading-normal px-[8px] mt-1' text={values?.['name'] && errors?.['name']} />
                                                                    </div>
                                                                </div>
                                                                <div className='w-[100%]' >
                                                                    <CustomInput name='person_name'
                                                                        value={values?.person_name}
                                                                        required={true}
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        label='Requesting Person’s Name' />
                                                                    <div className='h-[15px]'>
                                                                        <ParagraphComp className='text-[#C00000] text-[10px] leading-normal px-[8px] mt-1' text={values?.['person_name'] && errors?.['person_name']} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='w-[100%] flex gap-[10px]'>
                                                                <div className='w-[100%]' >
                                                                    <CustomInput
                                                                        value={values?.email}
                                                                        onChange={handleChange}
                                                                        required={true}
                                                                        onBlur={handleBlur}
                                                                        name='email' label='Email Id' />
                                                                    <div className='h-[30px]'>
                                                                        <ParagraphComp className='text-[#C00000] text-[10px] leading-normal px-[8px] mt-1' text={values?.['email'] && errors?.['email']} />
                                                                    </div>
                                                                </div>
                                                                <div className='w-[100%]' >
                                                                    <CustomInput
                                                                        value={values?.number}
                                                                        onChange={handleChange}
                                                                        required={true}
                                                                        onBlur={handleBlur}
                                                                        name='number' label='Mobile Number' />
                                                                    <ParagraphComp className='text-[#C00000] text-[10px] leading-normal px-[8px] mt-1' text={values?.['number'] && errors?.['number']} />
                                                                </div>
                                                            </div>
                                                            <ButtonComp type='submit' text="Submit" className='px-[40px] rounded-full bg-[#C00000] text-[white]' />
                                                        </div>
                                                        <DisplayFormikValues />

                                                    </Form>
                                                )}
                                            </Formik>
                                            : ''
                        }
                        {/* No Match Found for FCRA Number */}



                        {/* No Match Found for Organisation Name */}




                        {/* Organisation Found! */}



                        {/* Need Help? */}

                        {/* <div className='flex flex-col p-[30px] gap-[10px] items-center'>
                        <ImageComp source='./Images/QuestionMark.png' className='h-[100px] w-fit' />
                        <HeaderCompo tagType='h5' className='text-2xl mt-[20px] font-bold text-black mb-[0px] text-center' text='Need Help?' />
                        <ParagraphComp className='text-md text-center ' text='If you don’t have access to the registered email, reach out to us for support.' />
                        <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='Contact Details: ' />
                        <div className='flex gap-[5px] items-center '>
                            <MailIcon className='text-[black]' />
                            <ParagraphComp className='text-md text-center text-black ' text='support@yourorganisation.com' />
                        </div>
                        <div className='flex gap-[5px] items-center '>
                            <CallIcon className='text-[black]' />
                            <ParagraphComp className='text-md text-center text-black ' text='+1-234-567-890' />
                        </div>
                        <ButtonComp text="Close" className='px-[40px] rounded-full bg-[red] text-[white]' />
                    </div> */}

                        {/* Fill the Form */}
                    </div>
                    :
                    <div className='w-[100%] h-[100%] flex flex-col gap-[10px] '>
                        <div className='flex flex-col p-[30px] gap-[10px] items-center'>
                            <ImageComp source='./Images/organisationImg.png' className='h-[150px] w-fit' />
                            <HeaderCompo tagType='h5' className='text-2xl font-bold text-black mb-[0px] text-center' text='Organisation Found!' />
                            <div className='max-h-[250px] flex flex-col gap-[10px] w-[100%] overflow-x-hidden scroll-w-[10px] overflow-y-scroll '>

                                {filteredNpo?.map(npo => (
                                    <div
                                        onClick={() => { updateApplicationNum(npo?.name, npo?.db_name) }}
                                        className="w-[100%] cursor-pointer rounded-lg border-2 gap-[10px] flex p-[10px]"
                                    >
                                        <div className="w-[20%] rounded-lg h-[80px] bg-[#D9D9D9]">
                                            {npo?.org_logo && typeof npo.org_logo === 'string' && npo.org_logo.trim() ? (
                                                <img
                                                    src={`data:image/jpeg;base64,${npo?.org_logo}`}
                                                    alt="Organisation Logo"
                                                    className="w-full h-full object-cover"
                                                />
                                            ) : (
                                                <img
                                                    src="/Images/emptyImg.jpg" // Default image path
                                                    alt="Default Logo"
                                                    className="w-full h-full object-cover"
                                                />
                                            )}
                                        </div>
                                        <div className="w-[100%] flex justify-between items-center">
                                            <div className="flex flex-col">
                                                <HeaderCompo tagType="h5" className="text-xl text-black mb-[0px]" text={npo?.org_name} />
                                                <ParagraphComp className="text-md text-black" text={npo?.org_email} />
                                            </div>
                                            <div>
                                                <ParagraphComp className="text-green-700" text="Your ID Matches" />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <ParagraphComp className='text-md text-center leading-6 text-[#6F6C90]'
                                text='We seem to have found a match for the name you entered.
If you find your organisation is in the list of match(es), and if you have access, login directly. If you don’t have access, click Contact Us for assistance 
If your organisation is in none of the above, please click Register Now.
'
                            />
                            <div className='flex gap-[10px] w-[100%] '>
                                <ButtonComp onClick={() => closeModal()} text="Log In" className='px-[40px] w-[100%] rounded-full bg-[red] text-[white]' />
                                <ButtonComp onClick={() => { clearRegData() }} text="Register Now" className='px-[40px] w-[100%] rounded-full border-2 bg-[#004878] text-[white]' />
                                <ButtonComp onClick={() => { ContactBox('fill') }} text="Contact Us" className='px-[40px] w-[100%] rounded-full border-[#004878] border-2 text-[#004878]' />
                            </div>
                        </div>
                    </div>
                }
            </ModalComp >
        </>

    )
}

export default DatauserLogin